import React, { Component } from "react";
import {
  Container,
  Form,
  Row,
  Col,
  Button,
  Modal,
  Alert,
} from "react-bootstrap";
import ProductDetails from "../ProductDetails/ProductDetails";
import UserSummary from "../UserSummary/UserSummary";
import Loading from "../UI/Spinner/Spinner";
import AuthUser from "../Auth/Auth";
import * as constant from "../../Constant";
import UserContext from "../../context/user-context";
import axios from "../../axios-private-http.js";
import CurrentProduct from "../CurrentProduct/CurrentProduct";
import "./CreateRequest.css";
import "../../styles/Common.css";

class CreateRequest extends Component {
  static contextType = UserContext;
  newAssetConfirmationMessage = "";

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      currentProduct: [],
      repairProduct: [],
      productToSwap: "",
      assetIdProductToSwap: "",
      assetManuallyEntered: "",
      productToDeliver: "",
      selectedResolution: "",
      selectedWorkFlowType: "",
      selectedNotification: "",
      setShowConfirmation: false,
      showNewCartMessage: false,
      woComment: "",
      selectedNotificationValue: "",
      selectedNotificationErrorMsg: "",
      isUserSelectedResolutionCodeFromDropDown: false,
      swapWarningMessage: "",
      requestType: [],
      valid: true,
      isNotificationValid: true,
      errorMessage: "",
      errorHeader: "",
    };

    this.onSwapProduct = this.onSwapProduct.bind(this);
    this.onProductToSwapSelected = this.onProductToSwapSelected.bind(this);
    this.onAssetToSwapSelected = this.onAssetToSwapSelected.bind(this);
    this.assetManuallyEntered = this.assetManuallyEntered.bind(this);
  }

  componentDidMount() {
    if (sessionStorage.getItem("Loc") == null) {
      this.props.history.push("/");
    } else {
      this.setProductListAndRequestType();
    }
  }

  removeInvalidCharachtersFromPhone(phoneNumber){
    return !phoneNumber?phoneNumber:phoneNumber.replace(/\D/g,"")
  }

  formatPhoneNumber(phoneNumber) {
    phoneNumber = this.removeInvalidCharachtersFromPhone(phoneNumber);
    let formatPhoneNumber1 = "";
    let formatPhoneNumber2 = "";
    let formatPhoneNumber3 = "";
    if(!phoneNumber || phoneNumber.length === 0) {
      return "";
    }
    else {
      formatPhoneNumber1 =  (phoneNumber.length <= 3) ? phoneNumber : ("("+phoneNumber.substring(0, 3)+ ")");
      if(phoneNumber.length > 3) {
        formatPhoneNumber2 = " ";
        formatPhoneNumber2 = formatPhoneNumber2  + (phoneNumber.length < 6 ? phoneNumber.substring(3, phoneNumber.length) : phoneNumber.substring(3, 6));
      }
      if(phoneNumber.length > 6) { 
        formatPhoneNumber3 = "-"
        formatPhoneNumber3 = formatPhoneNumber3 + (phoneNumber.length < 10 ? phoneNumber.substring(6, phoneNumber.length) :phoneNumber.substring(6, 10));
      }
    }
    return formatPhoneNumber1 + formatPhoneNumber2 + formatPhoneNumber3;
  }

  setProductListAndRequestType() {
    const currentProduct = JSON.parse(sessionStorage.getItem("Products"));
    //this.props.location.state.customerInformation.customerLocationInformation[0].lstAssets;
    var repairProduct = [
      {
        defaultChecked: true,
        productName: "120 Liter Organics",
        productCode: "120 LiterOrganics",
        displayName: "Food Scraps Cart",
        productCount: 0,
        serialNumber: [],
      },
      {
        defaultChecked: false,
        productName: "120 liter Trash",
        productCode: "120 LiterTrash",
        displayName: "Small (120L) Garbage Cart",
        productCount: 0,
        serialNumber: [],
      },
      {
        defaultChecked: false,
        productName: "240 Liter Trash",
        productCode: "240 LiterTrash",
        displayName: "Large (240L) Garbage Cart",
        productCount: 0,
        serialNumber: [],
      },
      {
        defaultChecked: false,
        productName: "360 Liter Trash",
        productCode: "360 LiterTrash",
        displayName: "Excess (360L) Garbage Cart",
        productCount: 0,
        serialNumber: [],
      },
    ];
    var temp = [];
    var product = [];
    var tempSetLowerResolution = false;
    var tempSetBiggerResolution = false;

    if (currentProduct != null && currentProduct.length > 0) {
      currentProduct.forEach((item, i) => {
        var sNumber = {};
        var sNumbers = [];
        if (temp.indexOf(item.productCode) === -1) {
          temp.push(item.productCode);
          var _data = {};
          if (i === 0) {
            _data.defaultChecked = true;
            this.setState({ productToSwap: item.productCode });
          } else {
            _data.defaultChecked = false;
          }
          if (
            item.productName.includes("120") &&
            item.productName.toLowerCase().includes("trash")
          ) {
            tempSetLowerResolution = true;
            _data.displayName = "Small (120L) Garbage Cart";
          } else if (
            (item.productName.includes("240") &&
              item.productName.toLowerCase().includes("trash")) ||
            (item.productName.includes("360") &&
              item.productName.toLowerCase().includes("trash"))
          ) {
            tempSetBiggerResolution = true;
            if (item.productName.includes("240")) {
              _data.displayName = "Large (240L) Garbage Cart";
            } else {
              _data.displayName = "Excess (360L) Garbage Cart";
            }
          } else if (
            item.productName.includes("120") &&
            item.productName.toLowerCase().includes("organics")
          ) {
            _data.displayName = "Food Scraps Cart";
          } else {
            _data.displayName = item.productName;
          }

          _data.productName = item.productName;
          _data.productCode = item.productCode;
          _data.productCount = 1;
          sNumber.serialNumber = item.serialNumber;
          sNumber.assetId = item.assetId;
          sNumbers.push(sNumber);
          _data.serialNumber = sNumbers;
          product.push(_data);
        } else {
          for (var j = 0; j < product.length; j++) {
            if (product[j].productCode === currentProduct[i].productCode) {
              var _x = parseInt(product[j].productCount) + 1;
              // if (_x > 1) {
              //  product[j].productName =  product[j].productName;
              sNumber.serialNumber = item.serialNumber;
              sNumber.assetId = item.assetId;
              sNumbers = product[j].serialNumber;
              sNumbers.push(sNumber);
              product[j].serialNumber = sNumbers;
              // + " ("+_x+")";
              // }
              product[j].productCount = _x;
            }
          }
        }
      });

      product.forEach((item, i) => {
        repairProduct.forEach((repairItem, j) => {
          if (item.productCode === repairItem.productCode) {
            repairItem.serialNumber = item.serialNumber;
            repairItem.productCount = item.productCount;
          }
        });
      });

      this.setState({ currentProduct: product });
    }
    this.setState({ repairProduct: repairProduct });

    // Todo
    const requestTypeTemp = JSON.parse(sessionStorage.getItem("RequestType"));
    var requestType = [];

    requestTypeTemp.forEach((item, index) => {
      if (item.requestTypeCode.toUpperCase() === constant.SWAP_240L && tempSetLowerResolution) {
        requestType.push(item);
      } 
      else if ( (item.requestTypeCode.toUpperCase() === constant.SWAP_120L || item.requestTypeCode.toUpperCase() === constant.SWAP_360L) &&
        tempSetBiggerResolution) {
        requestType.push(item);
      } 
      else if ( item.requestTypeCode.toUpperCase() !== constant.SWAP_240L && item.requestTypeCode.toUpperCase() !== constant.SWAP_120L &&
        item.requestTypeCode.toUpperCase() !== constant.SWAP_360L) {
        requestType.push(item);
      }
    });

    this.setState({ requestType: requestType });
  }

  onProductToSwapSelected(value) {
    this.setState({ isUserSelectedResolutionCodeFromDropDown: false });
    this.setState({ productToSwap: value });
    if (value.includes("120") && this.state.selectedWorkFlowType === "Swap") {
      this.setState({ selectedResolution: constant.SWAP_240L });
    } else if (this.state.selectedWorkFlowType === "Swap") {
      this.setState({ selectedResolution: constant.SWAP_120L });
    }
  }

  onAssetToSwapSelected(value) {
    this.setState({ assetIdProductToSwap: value });
  }

  assetManuallyEntered(value) {
    this.setState({ assetManuallyEntered: value });
  }

  onSwapProduct(value) {
    if (this.state.productToDeliver !== value) {
      this.setState({ productToDeliver: value });
      this.setState({ showNewCartMessage: true });
    }
  }

  onChangeRequestType(event) {
    this.setState({ valid: true });
    this.setState({ isUserSelectedResolutionCodeFromDropDown: true });
    this.setState({ assetManuallyEntered: "" });
    this.setState({ productToDeliver: "" });
    this.setState({ assetIdProductToSwap: "" });
    if (
      event.target.childNodes[event.target.selectedIndex].text === "--Select--"
    ) {
      this.setState({ selectedResolution: "" });
      this.setState({ selectedWorkFlowType: "" });
      this.setState({ showNewCartMessage: false });
    } else {
      this.setState({ selectedResolution: event.target.value });
      this.setState({
        selectedWorkFlowType:
          event.target.childNodes[event.target.selectedIndex].getAttribute(
            "data"
          ),
      });
    }

    const workFlowType =
      event.target.childNodes[event.target.selectedIndex].getAttribute("data");
    if (workFlowType === "Swap") {
      if (
        sessionStorage.getItem("SwapMessage").includes("rate") &&
        sessionStorage.getItem("SwapMessage").includes("monthly")
      ) {
        this.setState({
          swapWarningMessage: sessionStorage.getItem("SwapMessage"),
        });
      }
    } else if (workFlowType === "Repair") {
      this.setState({ swapWarningMessage: "" });
    } else {
      this.setState({ swapWarningMessage: "" });
    }
  }

  onChangeNotificationValue(event) {
    if (event.target.value.length > event.target.maxLength) {
      event.target.value = event.target.value.slice(0, event.target.maxLength)
    }
    let valid = false;
    if (this.state.selectedNotification.toLowerCase() === "text" || this.state.selectedNotification.toLowerCase() === "phone") 
    {
      if (this.removeInvalidCharachtersFromPhone(event.target.value).length === 10 && this.removeInvalidCharachtersFromPhone(event.target.value).match('[0-9]{10}') ) {
        valid = true;
      }
      this.setState({ selectedNotificationValue: this.formatPhoneNumber(event.target.value) });
    }
    else if(this.state.selectedNotification.toLowerCase() === "email") {
      var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
      if (event.target.value !== "" && event.target.value.match(validRegex)) {
        valid = true
      }
        this.setState({ selectedNotificationValue: event.target.value });
      }
    else {
      valid = true;
    }
    if (valid) {
      this.setState({ 
        isNotificationValid: true, 
        selectedNotificationErrorMsg: ""
      });
    }
    else {
      this.setState({ 
        isNotificationValid: false 
      });
      }
      }

  onBlurNotificationValue(event) {
    let valid = true;
    if (this.state.selectedNotification.toLowerCase() === "text" || this.state.selectedNotification.toLowerCase() === "phone") 
    {
      if (!this.removeInvalidCharachtersFromPhone(event.target.value) || this.removeInvalidCharachtersFromPhone(event.target.value).length != 10 || 
      !(this.removeInvalidCharachtersFromPhone(event.target.value).match('[0-9]{10}')) ) {
        this.setState({ 
          isNotificationValid: false, 
          selectedNotificationErrorMsg: "Invalid Phone Number."
        });
        valid = false;
      }
    }
    else if(this.state.selectedNotification.toLowerCase() === "email") {
      var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
      if (event.target.value === "" || !event.target.value.match(validRegex)) {
        this.setState({ 
          isNotificationValid: false, 
          selectedNotificationErrorMsg: "Invalid Email Address."
        });
        valid = false;
      }
    }
    if(valid) {
      this.setState({ 
        isNotificationValid: true, 
        selectedNotificationErrorMsg: ""
      });
    }
  }

  onChangeNotification(event) {
    this.setState({ selectedNotification: event.target.value });
    this.setState({ selectedNotificationValue: "", selectedNotificationErrorMsg: "" });
  }

  onResetForm(event) {
    this.setState({ selectedResolution: "" });
    this.setState({ selectedWorkFlowType: "" });
    this.setState({ valid: true });
    document.querySelector("textarea").value = "";
    this.setState({ woComment: "" });
    this.setState({ swapWarningMessage: "" });
  }

  onCheckNotification(event) {}

  checkValidity() {
    var message = this.state.selectedNotificationErrorMsg ? "\n"+this.state.selectedNotificationErrorMsg : this.state.selectedNotificationErrorMsg;
    if (this.state.selectedResolution === null || this.state.selectedResolution === "") {
      message = "\nPlease select the service requested.";
    }
    else if ((this.state.assetIdProductToSwap === null || this.state.assetIdProductToSwap === "")
      && (this.state.assetManuallyEntered === null || this.state.assetManuallyEntered === "")
      && this.state.selectedResolution.toUpperCase() !== constant.SELECT_A_NEW_CART) {
      message = "\nSerial number is mandatory. Please enter the serial number of the Asset that you want us to service in the provided field.";
    }
    else if(!this.state.selectedNotification) {
      message = "\nPlease select the notification type.";
    }
    else if (!this.state.isNotificationValid || (!this.state.selectedNotificationValue && this.state.selectedNotification !== "noReminder")) {
      if(this.state.selectedNotification.toLowerCase() === "text" || this.state.selectedNotification.toLowerCase() === "phone"){
        message = (this.state.selectedNotificationValue) ? "\nNotifications field has invalid phone number." : "\nNotifications field has missing phone number.";
      }
      else if(this.state.selectedNotification.toLowerCase() === "email") {
        message = (this.state.selectedNotificationValue) ? "\nNotifications field has invalid email address." : "\nNotifications field has missing email address.";
      }
      else {
        message = "\nNotification value is missing/Invalid.";
      }
    }

    this.setState({ errorMessage: message });
    this.setState({ errorHeader: "Required Field" });
    if (message.length === 0) {
      this.setState({ valid: true });
      return true;
    } else {
      this.setState({ valid: false });
      return false;
    }
  }

  onSubmitClicked = (event) => {
    if (this.checkValidity()) {
      this.generateTokenAndSubmitServiceRequest();
    }
  };

  generateTokenAndSubmitServiceRequest() {
    //const {token} = this.context;
    this.setState({ loading: true });
    //  if(token.length <= 0 ) {
    AuthUser.getSFToken(
      sessionStorage.getItem("Seg"),
      this.setSFToken,
      this.setSFTokenError
    );
    //  } else {
    //      this.submitServiceRequestAPI();
    //  }
  }

  setSFToken = (token) => {
    const { setSFToken } = this.context;
    this.setState({ token: token });
    setSFToken(token);
    this.submitServiceRequestAPI();
  };

  setSFTokenError = (errorMessage) => {
    //this.submitServiceRequestAPI();
    this.setState({ loading: false });
    this.setState({ errorHeader: "Error" });
    this.setState({ errorMessage: errorMessage });
    this.setState({ valid: false });
  };

  submitServiceRequestAPI() {
    if (!this.state.loading) {
      this.setState({ loading: true });
    }
    const locationId = sessionStorage.getItem("Loc");
    const billAccountNumber = sessionStorage.getItem("AccountNumber");
    var phone = "";
    var email = "";
    if (this.state.selectedNotification.toLowerCase() === "email") {
      email = this.state.selectedNotificationValue;
    } else {
      phone = this.removeInvalidCharachtersFromPhone(this.state.selectedNotificationValue);
    }

    var productToDeliverOrService = "";
    var productToRemove = "";
    var resolutionCode = "";
    if (this.state.selectedWorkFlowType === "Swap") {
      productToRemove = this.state.productToSwap;
      productToDeliverOrService =
        this.state.productToDeliver + productToRemove.replace(/[0-9]/g, "");
    } else {
      productToDeliverOrService = this.state.productToSwap;
    }

    if (
      this.state.selectedResolution.toUpperCase() === constant.SELECT_A_NEW_CART
    ) {
      resolutionCode = constant.DELIVER_NEW_CART;
      if (this.state.productToDeliver === "120") {
        productToDeliverOrService = constant.DELIVER_120L_TRASH;
      } else {
        productToDeliverOrService = constant.DELIVER_240L_TRASH;
      }
    } else {
      resolutionCode = this.state.selectedResolution;
    }

    const payLoad = {
      serviceProviderName:
        "" + process.env.REACT_APP_SERVICE_PROVIDER_NAME + "",
      billingAccountNumber: "" + billAccountNumber + "",
      customerLocationId: "" + locationId + "",
      requestTypeCode: "" + resolutionCode + "",
      productCode: "" + productToDeliverOrService + "",
      removedProductCode: "" + productToRemove + "",
      contactInfo: "" + (this.state.selectedNotification === "noReminder" ? "" : this.state.selectedNotification) + "",  
      emailAddress: "" + email + "",
      phone: "" + phone + "",
      cartSerialToBeServiced:
        this.state.assetIdProductToSwap.length === 0
          ? null
          : "" + this.state.assetIdProductToSwap + "",
      otherSerialNumber:
        this.state.assetManuallyEntered.length === 0
          ? null
          : "" + this.state.assetManuallyEntered + "",
      isNotify:
        this.state.selectedNotification === "Text" ||
        this.state.selectedNotification === "phone" ||
        this.state.selectedNotification === "email"
          ? true
          : false,
      WoNotes: "" + this.state.woComment + "",
      caseOrigin: "Web",
    };

    axios(this.state.token)
      .post("/importWebWorkOrder", JSON.stringify(payLoad))
      .then((response) => {
        if (response.data.StatusCode === "200") {
          this.setState({ errorHeader: "" });
          this.setState({ errorMessage: "" });
          this.newAssetConfirmationMessage = response.data.receivingCartInfo;
          const requestType = response.data.lstRequestTypeCategories;
          var requestTypeToShow = [];
          const select = {
            workflowType: "--Select--",
            reqestTypeCategory: "",
            requestTypeCode: "",
            requestTypeName: "--Select--",
          };
          if (this.state.accountNumber !== "") {
            requestTypeToShow = requestType;
            requestTypeToShow.unshift(select);
          } else {
            requestTypeToShow.push(select);
            requestType.forEach((item) => {
              if (item.reqestTypeCategory !== "Billable") {
                requestTypeToShow.push(item);
              }
            });
          }
          sessionStorage.setItem("RequestType", JSON.stringify(requestType));

          if (
            this.state.selectedResolution.toUpperCase() ===
            constant.SELECT_A_NEW_CART
          ) {
            this.setState({ setShowConfirmation: true });
          } else {
            this.props.history.push({
              pathname: "/view-request",
              state: { woCreated: true },
            });
          }
        } else if (response.data.StatusCode === "400") {
          this.setState({ errorHeader: "Error" });
          var message = "\n " + response.data.Message;
          this.setState({ errorMessage: message });
          this.setState({ valid: false });
        } else {
          this.setState({ errorHeader: "Error" });
          var messageEr = "\n Something went wrong.";
          this.setState({ errorMessage: messageEr });
          this.setState({ valid: false });
        }
        this.setState({ loading: false });
      })
      .catch((error) => {
        this.setState({ loading: false });
        this.setState({ errorHeader: "Error" });
        var message = "\n Something went wrong.";
        this.setState({ errorMessage: message });
        this.setState({ valid: false });
      });
  }

  onAddressEditButtonClick = () => {
    this.props.history.push({ pathname: "/", state: { isEdit: true } });
  };

  onModalOkClicked = (event) => {
    this.props.history.push({
      pathname: "/view-request",
      state: { woCreated: true },
    });
  };

  render() {
    // var loadingScreen = "";
    var currentProduct = "";
    var swapResolution = "";
    var notificationOptions = [];
    var notificationTextBox = "";
    var showErrorMessage = "";
    var requestTypeOptions = [];
    var loadingScreen = "";

    if (this.state.loading) {
      loadingScreen = <Loading />;
    }

    var swapWarningMessageStyle = {
      display: "none",
      position: "absolute",
    };

    var showAsList = {
      whiteSpace: "pre-line",
    };

    if (this.state.swapWarningMessage !== "") {
      swapWarningMessageStyle.display = "block";
    }

    if (!this.state.valid) {
      showErrorMessage = (
        <div>
          <br />
          <Alert variant="danger" style={showAsList}>
            <p>
              <b>{this.state.errorHeader}</b>
              {this.state.errorMessage}
            </p>
          </Alert>
        </div>
      );
    }

    if (this.state.loading) {
      loadingScreen = <Loading />;
    }

    if (
      this.state.requestType !== null &&
      this.state.requestType.length !== 0
    ) {
      this.state.requestType.map((item) => {
        if (item.requestTypeName.toUpperCase() === constant.SELECT_A_NEW_CART) {
          requestTypeOptions.push(
            <option
              key={item.requestTypeName}
              value={item.requestTypeName}
              data={item.workflowType}
            >
              {item.requestTypeName
                .replace("A1-", "")
                .replace("A2-", "")
                .replace("A3-", "")
                .replace("A4-", "")}
            </option>
          );
        } else {
          requestTypeOptions.push(
            <option
              key={item.requestTypeCode}
              value={item.requestTypeCode}
              data={item.workflowType}
            >
              {item.requestTypeName
                .replace("A1-", "")
                .replace("A2-", "")
                .replace("A3-", "")
                .replace("A4-", "")}
            </option>
          );
        }
      });
    }

    if (this.state.selectedNotification.length > 0) {
      var placeHolderText = "";
      if ( this.state.selectedNotification === "Text" || this.state.selectedNotification === "phone") {
        placeHolderText = "Please enter 10 digit phone number.";
      } 
      else if (this.state.selectedNotification === "email") {
        placeHolderText = "Please enter a valid e-mail.";
      }
      notificationTextBox = (
        <>
        <Form.Control
          type="text"
          className={
              !this.state.isNotificationValid
              ? "invalid-border"
              : ""
          }
            minLength={(this.state.selectedNotification === "Text" || this.state.selectedNotification === "phone") ? "14" : "3"}
            maxLength={(this.state.selectedNotification === "Text" || this.state.selectedNotification === "phone") ? "14" : "50"}
          key="notification"
          onChange={(event) => this.onChangeNotificationValue(event)}
            onBlur={(event) => this.onBlurNotificationValue(event)}
          value={this.state.selectedNotificationValue}
          placeholder={placeHolderText}
        />
         <span className="text-danger">{this.state.selectedNotificationErrorMsg}</span>
        </>
      );
    }

    var checkSMS = (
      <Form.Check
        type="radio"
        label="Text message"
        name="user-notification"
        id="formNotificationSMS"
        value="Text"
        key="Text"
        className={
          !this.state.valid &&
          this.state.selectedNotification &&
          this.state.selectedNotification.length === 0
            ? "invalid-border-radio"
            : ""
        }
        checked={this.state.selectedNotification === "Text"}
        onChange={(event) => this.onChangeNotification(event)}
      />
    );
    var checkPhone = (
      <Form.Check
        type="radio"
        label="Phone call"
        name="user-notification"
        id="formNotificationPhone"
        value="phone"
        key="phone"
        className={
          !this.state.valid &&
          this.state.selectedNotification &&
          this.state.selectedNotification.length === 0
            ? "invalid-border-radio"
            : ""
        }
        checked={this.state.selectedNotification === "phone"}
        onChange={(event) => this.onChangeNotification(event)}
      />
    );
    var checkEmail = (
      <Form.Check
        label="Email"
        type="radio"
        name="user-notification"
        id="formNotificationEmail"
        value="email"
        key="email"
        className={
          !this.state.valid &&
          this.state.selectedNotification &&
          this.state.selectedNotification.length === 0
            ? "invalid-border-radio"
            : ""
        }
        checked={this.state.selectedNotification === "email"}
        onChange={(event) => this.onChangeNotification(event)}
      />
    );
    var checkNoReminder = (
      <Form.Check
        label="No reminder, please"
        type="radio"
        name="user-notification"
        id="formNotificationNoReminder"
        value="noReminder"
        key="noReminder"
        className={
          !this.state.valid &&
          this.state.selectedNotification &&
          this.state.selectedNotification.length === 0
            ? "invalid-border-radio"
            : ""
        }
        checked={this.state.selectedNotification === "noReminder"}
        onChange={(event) => this.onChangeNotification(event)}
      />
    );
    if (this.state.selectedNotification === "Text") {
      notificationOptions.push(checkSMS);
      notificationOptions.push(notificationTextBox);
      notificationOptions.push(checkPhone);
      notificationOptions.push(checkEmail);
      notificationOptions.push(checkNoReminder);
    } else if (this.state.selectedNotification === "phone") {
      notificationOptions.push(checkSMS);
      notificationOptions.push(checkPhone);
      notificationOptions.push(notificationTextBox);
      notificationOptions.push(checkEmail);
      notificationOptions.push(checkNoReminder);
    } else if (this.state.selectedNotification === "email") {
      notificationOptions.push(checkSMS);
      notificationOptions.push(checkPhone);
      notificationOptions.push(checkEmail);
      notificationOptions.push(notificationTextBox);
      notificationOptions.push(checkNoReminder);
    } else {
      // for empty and noReminder
      notificationOptions.push(checkSMS);
      notificationOptions.push(checkPhone);
      notificationOptions.push(checkEmail);
      notificationOptions.push(checkNoReminder);
    }

    if (
      this.state.currentProduct != null &&
      this.state.currentProduct.length > 0
    ) {
      const currentProductList = this.state.currentProduct;
      var product = "";
      product = currentProductList.map((item) => (
        <div>
          <Col
            className="margin-bottom d-flex justify-content-left align-items-left text-to-lowercase"
            key={item.productCode}
          >
            <br />
            <Form.Check
              key={item.productName}
              type="radio"
              label={item.productName}
              value={item.productCode}
              defaultChecked={item.defaultChecked}
              onChange={(event) =>
                this.setState({ productToSwap: event.target.value })
              }
              name="available-product"
            />
          </Col>
        </div>
      ));
      currentProduct = product;
    }

    if (
      (this.state.currentProduct != null &&
        this.state.currentProduct.length > 0) ||
      this.state.selectedWorkFlowType === "Repair"
    ) {
      if (this.state.selectedWorkFlowType === "Swap") {
        swapResolution = (
          <Row>
            <Col sm={{ span: 4 }} md={{ span: 3 }}></Col>
            <Col className="product-list-width">
              {/* new code RDI-4285 */}
              {/* <br/> Please Select the cart you would like to return: */}
              <br /> Enter the serial number of your current garbage cart:
              <b className="text-red">*</b>
              <div className="current-product">
                <CurrentProduct
                  key="existing-product"
                  productList={this.state.currentProduct}
                  resolutionUserSelectedFromDropDown={
                    this.state.isUserSelectedResolutionCodeFromDropDown
                  }
                  selectedResolution={this.state.selectedResolution}
                  selectedProductToSwap={this.state.productToSwap}
                  productToSwap={this.onProductToSwapSelected}
                  assetIdProductToSwap={this.onAssetToSwapSelected}
                  isValid={this.state.valid}
                />
              </div>
              <div></div>
              {/* new code RDI-4285 */}
              {/* <br/> Please select the new cart you would like to receive: */}
              <br /> Select your new garbage cart size:
              <b className="text-red">*</b>
              <ProductDetails
                selectedProduct={this.state.productToSwap.split(" ")[0]}
                productToDeliver={this.onSwapProduct}
                stateSwapped={this.state.productToDeliver}
              />
              <br />
            </Col>
          </Row>
        );
      } else if (this.state.selectedWorkFlowType === "Deliver") {
        var lable = "";
        lable = "Please select the lost or stolen cart:";
        swapResolution = (
          <Row>
            <Col sm={{ span: 4 }} md={{ span: 3 }}></Col>
            <Col className="product-list-width">
              <br /> {lable}
              <div className="current-product">
                <CurrentProduct
                  key="existing-product"
                  productList={this.state.currentProduct}
                  resolutionUserSelectedFromDropDown={
                    this.state.isUserSelectedResolutionCodeFromDropDown
                  }
                  selectedResolution={this.state.selectedResolution}
                  selectedProductToSwap={this.state.productToSwap}
                  productToSwap={this.onProductToSwapSelected}
                  assetIdProductToSwap={this.onAssetToSwapSelected}
                  isValid={this.state.valid}
                />
              </div>
              <br />
            </Col>
          </Row>
        );
      } else if (this.state.selectedWorkFlowType === "Repair") {
        var lableRe = "";
        lableRe =
          "Please select the cart that you would like us to repair for you:";
        swapResolution = (
          <Row>
            <Col sm={{ span: 4 }} md={{ span: 3 }}></Col>
            <Col className="product-list-width">
              <br /> {lableRe} <b className="text-red">*</b>
              <div className="current-product">
                <CurrentProduct
                  key="existing-product"
                  productList={this.state.repairProduct}
                  resolutionUserSelectedFromDropDown={
                    this.state.isUserSelectedResolutionCodeFromDropDown
                  }
                  selectedResolution={this.state.selectedResolution}
                  selectedProductToSwap={this.state.productToSwap}
                  productToSwap={this.onProductToSwapSelected}
                  assetIdProductToSwap={this.onAssetToSwapSelected}
                  assetManuallyEntered={this.assetManuallyEntered}
                  isValid={this.state.valid}
                />
              </div>
              <br />
            </Col>
          </Row>
        );
      } else {
        swapResolution = null;
      }
    } else {
      if (this.state.selectedWorkFlowType === "") {
        swapResolution = null;
      } else {
        if (
          this.state.selectedResolution.toUpperCase() ===
          constant.SELECT_A_NEW_CART
        ) {
          var lableFst = "";
          lableFst = "Please select the cart you would like to receive:";
          swapResolution = (
            <div>
              <Row>
                <Col sm={{ span: 4 }} md={{ span: 3 }}></Col>
                <Col className="product-list-width">
                  <br /> {lableFst} <b className="text-red">*</b>
                  <div className="current-product">
                    <ProductDetails
                      selectedProduct={null}
                      productToDeliver={this.onSwapProduct}
                      stateSwapped={this.state.productToDeliver}
                    />
                  </div>
                  <br />
                </Col>
              </Row>
              ,
              {this.state.showNewCartMessage ? (
                <Row>
                  <Col sm={{ span: 4 }} md={{ span: 3 }}></Col>
                  <Col className="marging-bottom-20">
                    {sessionStorage.getItem("NewAssetSelectionMessage")}
                  </Col>
                </Row>
              ) : null}
            </div>
          );
        } else {
          swapResolution = (
            <Row>
              <Col sm={{ span: 4 }} md={{ span: 3 }}></Col>
              <Col className="product-list-width">
                <br />
                No assets to show. Please contact the Waste Customer Support
                Team at 780-496-5698 for any questions
                <br />
              </Col>
            </Row>
          );
        }
      }
    }

    return (
      <Container className="wrapper">
        <br />
        <UserSummary
          showEditButton={true}
          showCreateNewButton={false}
          onEditHandler={this.onAddressEditButtonClick}
        />
        <br />

        <Form>
          <Form.Group
            as={Row}
            controlId="formServiceToBePerformed"
            className="align-items-center"
          >
            <Col sm={{ span: 4 }} md={{ span: 3 }}>
              <strong>
                Service Requested <b className="text-red">*</b>
              </strong>
            </Col>
            <Col>
              <Form.Control
                as="select"
                className={
                  !this.state.valid &&
                  this.state.selectedResolution.length === 0
                    ? "invalid-border select-down-arrow"
                    : "select-down-arrow"
                }
                value={this.state.selectedResolution}
                onChange={(event) => this.onChangeRequestType(event)}
              >
                {requestTypeOptions}
              </Form.Control>
              <div className="invalid-feedback" style={swapWarningMessageStyle}>
                {this.state.swapWarningMessage}
              </div>
            </Col>
          </Form.Group>
          {swapResolution}

          <Form.Group
            as={Row}
            controlId="formHorizontalPassword"
            className="top-margin_by2"
          >
            <Col sm={{ span: 4 }} md={{ span: 3 }}>
              <strong>Comments</strong>
            </Col>
            <Col>
              <Form.Control
                as="textarea"
                placeholder="Please add any additional comments you think could help our maintenance crew, like specifying your unit number if you live in a multi-unit complex. Please note we are not taking any scheduling requests."
                rows={3}
                onBlur={(event) =>
                  this.setState({ woComment: event.target.value })
                }
                maxLength={255}
              />
            </Col>
          </Form.Group>
          <Form.Group as={Row} className="top-margin_by2">
            <Col
              sm={{ span: 4 }}
              md={{ span: 3 }}
              className="notification-padding"
            >
              <strong>
                Notifications <b className="text-red">*</b>
              </strong>
            </Col>
            <Col>
              We will send you a reminder 48 hours before your service date. How
              would you like to receive it?
              {notificationOptions}
            </Col>
          </Form.Group>

          <Form.Group
            as={Row}
            controlId="errorMessage"
            className="d-flex justify-content-between flex-wrap align-items-center"
          >
            <Col className="right-padding-zero">{showErrorMessage}</Col>
          </Form.Group>
          <br />

          <Form.Group
            as={Row}
            className="d-flex justify-content-end flex-wrap no-wrap"
          >
            <Col sm={{ span: 5 }} md={{ span: 3 }}>
              <Button
                variant="success"
                block
                onClick={(event) => this.onSubmitClicked(event)}
                className="green-button"
              >
                Submit
              </Button>
            </Col>
            <Col sm={{ span: 5 }} md={{ span: 3 }}>
              <Button
                variant="custom"
                block
                className="light-grey-button"
                onClick={(event) => this.onResetForm(event)}
              >
                Clear
              </Button>
            </Col>
          </Form.Group>
        </Form>
        {loadingScreen}

        <Modal
          show={this.state.setShowConfirmation}
          onHide={this.onModalClose}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>Confirmation</Modal.Title>
          </Modal.Header>
          <Modal.Body> {this.newAssetConfirmationMessage}</Modal.Body>
          <Modal.Footer>
            <Button
              variant="primary"
              onClick={(event) => this.onModalOkClicked(event)}
            >
              Ok
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
    );
  }
}

export default CreateRequest;
